// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3AXrH","disabled":"FileBtn_disabled__3I010","warn":"FileBtn_warn__3BY9z","fade":"FileBtn_fade__1Knjz"};